/* eslint-disable no-underscore-dangle */
import {useLazyQuery, useQuery} from '@apollo/client';
// import {GeneratedRound} from 'packages/common-types/base-types';
import {Result} from 'packages/common-types/schema-types';
import HeadingTitle from 'packages/common-ui/HeadingTitle';
import SelectTournament from 'packages/common-ui/SelectTournament';
import useCommonStyles from 'packages/common-utils/common-styles';
import {GET_NUMBER_OF_ROUNDS, GET_ROUND} from 'packages/graphql/v2/queries';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import useAppSelector from 'packages/hooks/use-app-selector';
import {useEffect} from 'react';
import {selectTournament} from 'redux/features/app-slice';
import {
  selectGeneratedRound,
  selectLoadedRound,
  selectSelectedRound,
  // setGeneratedRound,
  setLoadedRound,
  setRoundMetadataKey,
} from 'redux/features/round-slice';
import {initializeWorker, terminateWorker} from 'services/worker';
import useStyles from '../admin-styles';
import CurrentRound from './CurrentRound';
import RoundMenu from './Menu';
import MoveNextRound from './MoveNextRound';
import RoundsSelect from './RoundSelect';
import SaveRound from './SaveRound';

type GetRoundVars = {
  tournamentId: string;
  roundNumber: number;
};

type GetRoundData = {
  getRound: Result[];
};

type Vars = {
  tournamentId: string;
};
type Data = {
  getNumberOfRounds: number;
};

const Rounds = () => {
  const classes = useStyles();
  const common = useCommonStyles();
  const dispatch = useAppDispatch();
  const generatedRound = useAppSelector(selectGeneratedRound);
  const selectedRound = useAppSelector(selectSelectedRound);
  const selectedTournament = useAppSelector(selectTournament);
  const loadedRound = useAppSelector(selectLoadedRound);
  const {data: dataRounds, refetch} = useQuery<Data, Vars>(
    GET_NUMBER_OF_ROUNDS,
    {skip: true}
  );
  const [loadPreviousRound, {data}] = useLazyQuery<GetRoundData, GetRoundVars>(
    GET_ROUND
  );
  /**
   *  Load the data and set up in a global state.
   *  Send this data instead of the query data to clean the result
   */
  useEffect(() => {
    if (data) {
      dispatch(setLoadedRound(data.getRound));
    }
  }, [dispatch, data]);

  /**
   * Load the previous round except when the select has no value selected!
   */
  useEffect(() => {
    if (selectedRound.value !== '') {
      loadPreviousRound({
        variables: {
          tournamentId: selectedTournament?._id,
          roundNumber: +selectedRound.value,
        },
      });
    }
  }, [selectedRound, loadPreviousRound, selectedTournament?._id]);

  /**
   * Run the lazyQuery of getRounds to get the latest played round of the tournament.
   */
  useEffect(() => {
    async function getRounds() {
      const {data} =
        (await refetch({tournamentId: selectedTournament?._id})) || {};

      if (data) {
        const lastPlayedRound = data.getNumberOfRounds;

        dispatch(
          setRoundMetadataKey({key: 'currentRound', value: lastPlayedRound + 1})
        );
        dispatch(
          setRoundMetadataKey({key: 'nextRound', value: lastPlayedRound + 2})
        );
      }
    }
    /**
     * Run the effect just if the user selected a tournament and the round was generated
     */
    if ((selectedTournament && !selectedRound.value) || generatedRound) {
      getRounds();
    }
  }, [
    generatedRound,
    refetch,
    selectedTournament,
    dispatch,
    selectedRound.value,
  ]);

  /**
   * Initialize the worker and clean it on unmount.
   */
  useEffect(() => {
    initializeWorker();
    return () => {
      terminateWorker();
    };
  }, []);
  /**
   * 🧪 Test function to fill the generatedRound information.
   * TODO: Comment it after finishing testing...
   */
  // const testFill = () => {
  //   const testCopy = {...generatedRound};

  //   const modifiedTestTables = testCopy.tables.map((table) => {
  //     const tableCopy = {...table};

  //     let isEqual = true;
  //     let randomScore1;
  //     let randomScore2;

  //     do {
  //       randomScore1 = Math.floor(Math.random() * (200 - 150)) + 150;
  //       randomScore2 = Math.floor(Math.random() * (200 - 150)) + 150;
  //       const win = Math.floor(Math.random() * 2);
  //       if (win) {
  //         randomScore1 = 210;
  //       } else {
  //         randomScore2 = 210;
  //       }
  //       if (randomScore1 !== randomScore2) isEqual = false;
  //     } while (isEqual);

  //     tableCopy.result = {
  //       ...tableCopy.result,
  //       competitorOne: randomScore1,
  //       competitorTwo: randomScore2,
  //     };

  //     return tableCopy;
  //   });

  //   const newRound: GeneratedRound = {
  //     index: testCopy.index,
  //     tables: modifiedTestTables,
  //   };

  //   dispatch(setGeneratedRound(newRound));
  // };

  const renderMoveNextRound = () => {
    if (selectedRound?.value !== -1) return null;
    return (
      <>
        {dataRounds?.getNumberOfRounds !==
          selectedTournament?.conditions.numberOfRounds && <MoveNextRound />}

        {dataRounds?.getNumberOfRounds ===
          selectedTournament?.conditions.numberOfRounds && (
          <MoveNextRound renderFinished />
        )}
      </>
    );
  };

  return (
    <div className={classes.rn_root}>
      <div className={classes.rn_select_container}>
        <div className={classes.rn_selects_left_side}>
          <div style={{width: 300, marginRight: 14}}>
            <SelectTournament />
          </div>
          <div style={{width: 300, marginRight: 14}}>
            <RoundsSelect />
          </div>
        </div>
        <div style={{display: 'flex'}}>
          <SaveRound />
          {renderMoveNextRound()}
        </div>
      </div>
      {/* <button onClick={testFill} type="button">
        Random test
      </button> */}
      <div style={{width: '100%', marginTop: 30}}>
        {(loadedRound || generatedRound) && (
          <>
            <div className={common.row_btw}>
              <HeadingTitle
                title={`${
                  selectedRound.value !== -1
                    ? `Ronda número ${selectedRound.value + 1}`
                    : `Ronda actual`
                }`}
              />
              {selectedTournament && <RoundMenu />}
            </div>
            <CurrentRound
              tournamentId={selectedTournament?._id}
              previousRound={loadedRound}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Rounds;
